import React, { useState, useEffect } from 'react';
//Context
import { useReportes } from './ReportesContex';
//Components
import DateRangePicker from './DateRangePicker';
import SelectJerarquiaReportes from './SelectJerarquiaReportes';
//Material UI
import { Button, TextField, Checkbox, ListItemText as MuiListItemText } from '@material-ui/core';
import { Eye, FileSpreadsheet } from 'tabler-icons-react';
import '../../styles/reportes.css';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { MenuItem } from '@material-ui/core';
// Date picker
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import esLocale from 'date-fns/locale/es';

// Todos los índices usan DateRangePicker
const INDICES_DATERANGE = [1, 2, 3, 4, 5, 7, 8, 10, 11];
// Índices que usan selector de fecha única (un solo día)
const INDICES_SINGLE_DATE = [9];
// Índices que muestran selector de celda (OEE)
const INDICES_CELDA = [1];
// Índices que muestran selector de periodo: tiempos perdidos(3), indicadores(4)
const INDICES_PERIODO = [3, 4];
// Índices que muestran selector incidencia/tiempo: informe2(7)
const INDICES_SELECTOR = [7];
// Índices que muestran selector de cantidad (Top N): top llamadas(10)
const INDICES_TOPN = [10];

export default function Botones() {
    const {
        txtRange,
        getReports,
        getCorridas,
        celdas,
        setCelda,
        celda,
        selectedIndex,
        periodo,
        setPeriodo,
        getPerdidos,
        selector,
        setSelector,
        getSumaParos,
        setXData,
        setData,
        getIndicadores,
        setDataE,
        setDataX,
        setDataMttr,
        setDataMtbf,
        setDataU,
        setDataP,
        setFechaHoraFin,
        setFechaHoraIni,
        getLineaTiempoHist,
        setDataL,
        setDataPie,
        filteredLines,
        getInformeProduccion,
        setInformeProduccionData,
        selectedArea,
        selectedLinea,
        getReporteOperacion,
        setReporteOperacionData,
        setTPerdidosFetched,
        exportFn,
        topN,
        setTopN,
        getTopLlamadas,
        setTopLlamadas,
        areasAtencion,
        areaAtencion,
        setAreaAtencion,
        esDowntime,
        setEsDowntime,
        setInformeProduccionDiariaData,
        getInformeProduccionDiaria,
    } = useReportes();
    const [tiempoAtras] = useState(0);
    const [roFecha, setRoFecha] = useState(() => new Date());
    const [ipSelectedLineas, setIpSelectedLineas] = useState([]);
    const [ipSku, setIpSku] = useState('');
    const [ipOrden, setIpOrden] = useState('');

    // Reset en cascada cuando cambia el área
    useEffect(() => {
        setIpSelectedLineas([]);
    }, [selectedArea]);

    useEffect(() => {
        if (ipSelectedLineas.length === 0) {
            setIpSku('');
            setIpOrden('');
        }
    }, [ipSelectedLineas]);

    useEffect(() => {
        let fechaActual = new Date().toLocaleString().split(/[/,]+/);
        fechaActual[3] = fechaActual[3].trim();
        let tempHora = fechaActual[3].trim().split(':');
        if (parseInt(tempHora[0]) < 10) {
            tempHora[0] = `0${tempHora[0]}`;
        }
        fechaActual[3] = `${tempHora[0]}:${tempHora[1]}`;
        if (parseInt(fechaActual[1]) < 10) fechaActual[1] = `0${fechaActual[1]}`;
        if (parseInt(fechaActual[0]) < 10) fechaActual[0] = `0${fechaActual[0]}`;

        let fechaIni = new Date();
        fechaIni = new Date(fechaIni.setHours(tiempoAtras)).toLocaleString().split(/[/,]+/);
        tempHora = fechaIni[3].trim().split(':');
        if (parseInt(tempHora[0]) < 10) tempHora[0] = `0${tempHora[0]}`;
        if (parseInt(tempHora[1]) < 10) tempHora[1] = `0${tempHora[1]}`;
        fechaIni[3] = `${tempHora[0]}:${tempHora[1]}`;
        if (parseInt(fechaIni[1]) < 10) fechaIni[1] = `0${fechaIni[1]}`;
        if (parseInt(fechaIni[0]) < 10) fechaIni[0] = `0${fechaIni[0]}`;

        setFechaHoraIni(`${fechaIni[2]}-${fechaIni[1]}-${fechaIni[0]}T00:00`);
        setFechaHoraFin(`${fechaActual[2]}-${fechaActual[1]}-${fechaActual[0]}T${fechaActual[3]}`);
    }, [setFechaHoraFin, setFechaHoraIni, tiempoAtras]);

    const showDateRange = INDICES_DATERANGE.includes(selectedIndex);
    const showSingleDate = INDICES_SINGLE_DATE.includes(selectedIndex);
    const showCelda = INDICES_CELDA.includes(selectedIndex);
    const showPeriodo = INDICES_PERIODO.includes(selectedIndex);
    const showSelector = INDICES_SELECTOR.includes(selectedIndex);
    const showTopN = INDICES_TOPN.includes(selectedIndex);

    return (
        <div className="graphReport">
            <div className="graphReportFirst">

                {/* Selectores de jerarquía — todos los informes */}
                <SelectJerarquiaReportes />

                {/* DateRangePicker — todos los informes */}
                <div className={`botones-daterange${showDateRange ? '' : ' botones-hidden'}`}>
                    <TextField
                        label="Rango fechas"
                        value={txtRange}
                        InputProps={{ readOnly: true }}
                    />
                    <DateRangePicker />
                </div>

                {/* Filtros Informe de Producción (index 8) */}
                {process.env.REACT_APP_ALLOW_REPORTS_INFORME_PRODUCCION === 'true' && (
                    <div className={`ip-botones-filters${selectedIndex === 8 ? '' : ' botones-hidden'}`}>
                        <FormControl className="graphReport-formControl" disabled={!selectedArea}>
                            <InputLabel>Líneas</InputLabel>
                            <Select
                                multiple
                                value={ipSelectedLineas}
                                onChange={(e) => setIpSelectedLineas(e.target.value)}
                                renderValue={(selected) =>
                                    selected.length === 0 || selected.length === filteredLines.length
                                        ? 'Todas'
                                        : `${selected.length} línea(s)`
                                }
                            >
                                {filteredLines.map((l) => (
                                    <MenuItem key={l.id} value={l.id}>
                                        <Checkbox
                                            checked={ipSelectedLineas.includes(l.id)}
                                            color="primary"
                                            size="small"
                                        />
                                        <MuiListItemText primary={l.nombre} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            label="SKU"
                            value={ipSku}
                            onChange={(e) => setIpSku(e.target.value)}
                            className="ip-filter-textfield"
                            disabled={ipSelectedLineas.length === 0}
                        />
                        <TextField
                            label="Orden"
                            value={ipOrden}
                            onChange={(e) => setIpOrden(e.target.value)}
                            className="ip-filter-textfield"
                            disabled={ipSelectedLineas.length === 0}
                        />
                    </div>
                )}

                {/* Selector de fecha única — Reporte de operación (index 9) */}
                {process.env.REACT_APP_ALLOW_REPORTS_OPERACION === 'true' && (
                    <div className={`ro-botones-date${showSingleDate ? '' : ' botones-hidden'}`}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Seleccione un día"
                                format="dd/MM/yyyy"
                                value={roFecha}
                                onChange={(date) => setRoFecha(date)}
                                KeyboardButtonProps={{ 'aria-label': 'cambiar fecha' }}
                                className="ro-date-input"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                )}

                {/* Controles OEE: celda, periodo, selector */}
                {process.env.REACT_APP_ALLOW_REPORTS_OEE_MODULE === 'true' && (
                    <div className="botones-oee-controls">
                        <div className={`graphReport-selectCelda${showCelda ? '' : ' botones-hidden'}`}>
                            <FormControl className="graphReport-formControl">
                                <InputLabel htmlFor="celda">Seleccione una celda</InputLabel>
                                <Select
                                    value={celda}
                                    onChange={(e) => setCelda(e.target.value)}
                                    disabled={selectedIndex === 5}
                                >
                                    {celdas.map((item, index) => (
                                        <MenuItem value={item.celda1} id={index} key={index}>
                                            {item.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <FormControl className={`graphReport-formControl-spaced${showPeriodo ? '' : ' botones-hidden'}`}>
                            <InputLabel htmlFor="periodo">Seleccione periodo</InputLabel>
                            <Select
                                value={periodo}
                                onChange={(e) => setPeriodo(e.target.value)}
                            >
                                <MenuItem value={1}>Meses</MenuItem>
                                <MenuItem value={2}>Semanas</MenuItem>
                                <MenuItem value={3}>Dias</MenuItem>
                                <MenuItem value={4}>Horas</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl className={`graphReport-formControl${showSelector ? '' : ' botones-hidden'}`}>
                            <InputLabel htmlFor="selector">Seleccione una opción</InputLabel>
                            <Select
                                value={selector}
                                onChange={(e) => setSelector(e.target.value)}
                            >
                                <MenuItem value={1}>Incidencia</MenuItem>
                                <MenuItem value={0}>Tiempos (min)</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                )}

                {/* Filtros Top Llamadas (index 10) */}
                <div className={`botones-topllamadas-controls${showTopN ? '' : ' botones-hidden'}`}>
                    <FormControl className="graphReport-formControl-sm">
                        <InputLabel htmlFor="topN">Cantidad</InputLabel>
                        <Select
                            value={topN}
                            onChange={(e) => setTopN(e.target.value)}
                        >
                            <MenuItem value={5}>Top 5</MenuItem>
                            <MenuItem value={10}>Top 10</MenuItem>
                            <MenuItem value={15}>Top 15</MenuItem>
                            <MenuItem value={20}>Top 20</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl className="graphReport-formControl-area">
                        <InputLabel htmlFor="areaAtencion">Área de atención</InputLabel>
                        <Select
                            value={areaAtencion}
                            onChange={(e) => setAreaAtencion(e.target.value)}
                        >
                            <MenuItem value={-1}>Todas</MenuItem>
                            {areasAtencion.map((a) => (
                                <MenuItem key={a.codigo} value={a.codigo}>
                                    {a.nombre}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl className="graphReport-formControl-sm">
                        <InputLabel htmlFor="esDowntime">Es paro</InputLabel>
                        <Select
                            value={esDowntime}
                            onChange={(e) => setEsDowntime(e.target.value)}
                        >
                            <MenuItem value={-1}>Ambos</MenuItem>
                            <MenuItem value={0}>No</MenuItem>
                            <MenuItem value={1}>Sí</MenuItem>
                        </Select>
                    </FormControl>
                </div>

            </div>

            <div className="graphReport-div">
                {exportFn && (
                    <Button
                        variant="outlined"
                        color="primary"
                        className="graphReport-button graphReport-button--export"
                        onClick={exportFn}
                    >
                        <FileSpreadsheet size={20} className="graphReport-button-icon" />
                        <span>Exportar Excel</span>
                    </Button>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    className="graphReport-button"
                    onClick={() => {
                        if (selectedIndex === 9) {
                            setReporteOperacionData(null);
                            const d = roFecha instanceof Date ? roFecha : new Date(roFecha);
                            const fechaStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                            getReporteOperacion({ fecha: fechaStr, linea: selectedLinea?.id ?? 0 });
                        } else if (selectedIndex === 8) {
                            setInformeProduccionData([]);
                            getInformeProduccion({ lineas: ipSelectedLineas, sku: ipSku, orden: ipOrden });
                        } else if (selectedIndex === 1) {
                            setData([]);
                            setXData([]);
                            getReports();
                        } else if (selectedIndex === 2) {
                            setDataE([]);
                            setDataX([]);
                            setDataP([]);
                            getCorridas();
                        } else if (selectedIndex === 3) {
                            setDataU([]);
                            setDataL([]);
                            setDataPie([]);
                            setTPerdidosFetched(false);
                            getPerdidos();
                        } else if (selectedIndex === 4) {
                            setDataMtbf([]);
                            setDataMttr([]);
                            setDataU([]);
                            setDataP([]);
                            getIndicadores();
                        } else if (selectedIndex === 5) {
                            getLineaTiempoHist();
                        } else if (selectedIndex === 7) {
                            setDataL([]);
                            setDataPie([]);
                            getSumaParos();
                        } else if (selectedIndex === 10) {
                            setTopLlamadas({ topIncidencias: [], topDuracion: [] });
                            getTopLlamadas();
                        } else if (selectedIndex === 11) {
                            setInformeProduccionDiariaData([]);
                            getInformeProduccionDiaria();
                        }
                    }}
                >
                    <Eye size={20} className="graphReport-button-icon" />
                    <span>Ver Reporte</span>
                </Button>
            </div>
        </div>
    );
}
